import React, { Component } from 'react';
import { SvgIcon } from 'core/icons';
import { Checkbox } from 'core/controls';

class OptionCheckbox extends Component {
  handleChange(event) {
    event.preventDefault();
    this.props.onChange();
  }

  renderWarning() {
    const { conflict, analyticsKey, analyticsKey2, onChange } = this.props;

    if (!conflict) {
      return null;
    }

    return (
      <button
        onClick={onChange}
        data-dtm={analyticsKey}
        data-dtm2={analyticsKey2}
        className="stat-image-link">
        <SvgIcon name="bell-o" className="option-checkbox__alert" />
      </button>
    );
  }

  render() {
    const { id, checked, disabled, analyticsKey, analyticsKey2 } = this.props;

    return (
      <div className="option__checkbox">
        <Checkbox
          id={id}
          checked={checked}
          disabled={disabled}
          analyticsKey={analyticsKey}
          analyticsKey2={analyticsKey2}
          onChange={e => this.handleChange(e)}
        />
        {this.renderWarning()}
      </div>
    );
  }
}

export default OptionCheckbox;
